import { Link } from "../lib/router";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";
import { umamiEvent } from "../lib/analytics";
import { useTranslation } from "react-i18next";

interface HomeLinkProps {
  textClassName?: string;
}

export function HomeLink({ textClassName = "" }: HomeLinkProps) {
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  return (
    <Link
      to="/"
      {...umamiEvent("home-link")}
      aria-label={t("components.homeLink.alt")}
      className={`flex items-center gap-2 cursor-pointer ${theme.text} transition-transform duration-150 hover:-rotate-2 rounded-lg p-1 -ml-1`}
    >
      <span
        aria-hidden="true"
        className="flex h-9 w-9 items-center justify-center rounded-[10px] border-[3px] border-ink bg-gold font-display text-lg text-ink shadow-board-sm"
      >
        W
      </span>
      <span
        className={`hidden sm:block font-display text-xl uppercase tracking-tight ${isDark ? "text-white [text-shadow:0_3px_0_var(--color-ink)]" : "text-ink"} ${textClassName}`}
      >
        {t("components.homeLink.text")}
      </span>
    </Link>
  );
}
